import { render, staticRenderFns } from "./TkFroala.vue?vue&type=template&id=50db7aa8&"
import script from "./TkFroala.vue?vue&type=script&lang=js&"
export * from "./TkFroala.vue?vue&type=script&lang=js&"
import style0 from "./TkFroala.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports